module.exports = __webpack_public_path__ + "static/media/15-10.90eb9dcf.mp3";